<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3 class="font-weight-bold" v-text="'Gift Redemption'"></h3>
              <!-- <v-btn
                class="mx-2 mb-2"
                fab
                x-small
                color="primary"
                to="/gift-redemptions/create"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        rounded
                        depressed
                        color="success"
                        class="my-auto mr-2"
                        @click="showExcelDialog = true"
                        :loading="isDownloading"
                        style="width: 90px; height: 50px"
                      >
                        <v-icon dark> mdi-download </v-icon>
                      </v-btn>
                    </template>
                    <span>Download Excel</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        rounded
                        depressed
                        color="error"
                        class="my-auto"
                        @click="deleteAll(gift_redemptions.id)"
                        style="width: 90px; height: 50px"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete all Gift Redemption</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">user</th>
                      <th class="text-left" style="min-width: none">Gift</th>
                      <th class="text-left" style="min-width: none">Store</th>
                      <th class="text-left" style="min-width: none">Date</th>
                      <th class="text-left" style="min-width: none">
                        Quantity
                      </th>
                      <th class="text-left" style="min-width: 120px">Image</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="gift_redemptions.length != 0">
                    <tr
                      v-for="(gift_redemption, i) in gift_redemptions"
                      :key="`gift_redemption_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': gift_redemptions.length - 1 == i,
                      }"
                    >
                      <td>
                        <input
                          type="checkbox"
                          v-model="gift_redemption.is_selected"
                        />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="gift_redemption.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span> Gift Redemption is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="gift_redemption.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Gift Redemption is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{
                          gift_redemption.user
                            ? gift_redemption.user.user_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          gift_redemption.store_gift.gift
                            ? gift_redemption.store_gift.gift.name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          gift_redemption.store
                            ? gift_redemption.store.store_location
                            : ""
                        }}
                      </td>
                      <td>
                        {{ formatDate(gift_redemption.created_at) }}
                      </td>

                      <td>
                        {{ gift_redemption.quantity || "" }}
                      </td>
                      <td>
                        <div v-if="gift_redemption.image_path" class="image-container">
                          <v-img
                            :src="mediaUrl + gift_redemption.image_path"
                            alt="Gift Redemption Image"
                            height="60"
                            width="80"
                            contain
                            class="rounded cursor-pointer"
                            @click="showImageModal(gift_redemption.image_path)"
                          />
                        </div>
                        <div v-else class="no-image">
                          <v-icon color="grey lighten-2" size="40">mdi-image-off</v-icon>
                          <div class="text-caption grey--text">No Image</div>
                        </div>
                      </td>
                      <td class="text-right">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              class="my-auto"
                              color="error"
                              @click="Delete_this(gift_redemption.id)"
                            >
                              <v-icon dark> mdi-delete </v-icon>
                            </v-btn>
                          </template>
                          <span>Delete this Gift Redemption</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2"
                              fab
                              x-small
                              color="primary"
                              :to="`/gift-redemptions/${encryptIt(
                                gift_redemption.id
                              )}`"
                            >
                              <v-icon dark> mdi-pencil </v-icon>
                            </v-btn>
                          </template>
                          <span>Edit this Gift Redemption</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="9" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Excel Download Dialog -->
      <v-dialog v-model="showExcelDialog" max-width="500" persistent>
        <v-card rounded="xxl">
          <v-card-title class="d-flex justify-space-between">
            <span class="headline">
              <v-icon left color="success">mdi-file-excel</v-icon>
              Download Excel Report
            </span>
            <v-btn icon @click="closeExcelDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <h4 class="mb-3">Export Options</h4>
                  <v-radio-group 
                    v-model="downloadDialog.exportType" 
                    row 
                    class="mb-3"
                    @change="updateExportDescription"
                  >
                    <v-radio
                      label="Fast Export (Text Only)"
                      value="fast"
                      color="success"
                    ></v-radio>
                    <v-radio
                      label="Detailed Export (With Images)"
                      value="detailed"
                      color="primary"
                    ></v-radio>
                  </v-radio-group>
                  
                  <v-alert
                    :type="downloadDialog.exportType === 'fast' ? 'success' : 'info'"
                    outlined
                    dense
                    class="mb-4"
                  >
                    <div class="d-flex align-center">
                      <v-icon left>{{ downloadDialog.exportType === 'fast' ? 'mdi-flash' : 'mdi-image-multiple' }}</v-icon>
                      <span>{{ downloadDialog.exportDescription }}</span>
                    </div>
                  </v-alert>
                  
                  <h4 class="mb-3">Select Date Range (Optional)</h4>
                  <p class="text-caption grey--text mb-4">
                    Leave empty to download all records, or select a date range to filter the data.
                  </p>
                </v-col>
              </v-row>
              
              <v-row>
                <v-col md="6">
                  <v-menu
                    v-model="downloadDialog.fromDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="downloadDialog.from_date"
                        label="From Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="downloadDialog.from_date = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="downloadDialog.from_date"
                      @input="downloadDialog.fromDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                
                <v-col md="6">
                  <v-menu
                    v-model="downloadDialog.toDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="downloadDialog.to_date"
                        label="To Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="downloadDialog.to_date = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="downloadDialog.to_date"
                      @input="downloadDialog.toDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              
              <v-row v-if="downloadDialog.from_date || downloadDialog.to_date">
                <v-col cols="12">
                  <v-alert
                    type="info"
                    outlined
                    class="mb-0"
                  >
                    <div class="d-flex align-center">
                      <v-icon left>mdi-information</v-icon>
                      <div>
                        <strong>Selected Range:</strong><br>
                        <span v-if="downloadDialog.from_date">
                          From: {{ formatDateDisplay(downloadDialog.from_date) }}
                        </span>
                        <span v-if="downloadDialog.from_date && downloadDialog.to_date"> | </span>
                        <span v-if="downloadDialog.to_date">
                          To: {{ formatDateDisplay(downloadDialog.to_date) }}
                        </span>
                      </div>
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          
          <v-card-actions class="px-6 pb-6">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              @click="closeExcelDialog"
            >
              Cancel
            </v-btn>
            <v-btn
              color="success"
              depressed
              @click="downloadExcelFromDialog()"
              :loading="isDownloading"
              class="ml-3"
            >
              <v-icon left>mdi-download</v-icon>
              Download Excel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Image Preview Modal -->
      <v-dialog v-model="imageModal" max-width="600">
        <v-card rounded="xxl">
          <v-card-title class="d-flex justify-space-between">
            <span>Gift Redemption Image</span>
            <v-btn icon @click="imageModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <v-img
              v-if="selectedImagePath"
              :src="mediaUrl + selectedImagePath"
              alt="Gift Redemption Image"
              max-height="400"
              contain
              class="rounded"
            />
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn 
              color="primary" 
              @click="openImageInNewTab" 
              outlined
              class="mr-2"
            >
              <v-icon left>mdi-open-in-new</v-icon>
              Open Full Size
            </v-btn>
            <v-btn color="secondary" @click="imageModal = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_gift_redemption" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift Redemption deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_gift_redemption = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "GiftRedemptionsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
      },
      showExcelDialog: false,
      downloadDialog: {
        from_date: null,
        to_date: null,
        fromDateMenu: false,
        toDateMenu: false,
        exportType: 'fast',
        exportDescription: 'Quick download with all data except images. Recommended for large datasets.',
      },
      gift_redemptions: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      delete_gift_redemption: false,
      is_deleted_gift_redemption: false,
      is_select_all: false,
      isDeleteAll: false,
      isDownloading: false,
      imageModal: false,
      selectedImagePath: null,
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`gift_redemptions?${query}`)
        .then((response) => {
          this.gift_redemptions = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async Delete_this(id) {
      this.delete_gift_redemption = true;
      await axios
        .post(`/gift_redemptions/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_gift_redemption = false;
          this.is_deleted_gift_redemption = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.gift_redemptions.forEach((gift_redemption) => {
        gift_redemption.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.gift_redemptions.forEach((gift_redemption) => {
        if (gift_redemption.is_selected) deleteallIds.push(gift_redemption);
      });
      await axios
        .post("/gift_redemptions/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/update_date_all, this.form);
      this.isDeleteAll = false;
    },
    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },
    async downloadExcel(from_date = null, to_date = null, exportType = 'fast') {
      this.isDownloading = true;
      try {
        // Build query parameters from current filters and dialog date filters
        let query = new URLSearchParams({
          is_active: this.filter.is_active || "",
          search_keyword: this.filter.search_keyword || "",
          from_date: from_date || "",
          to_date: to_date || "",
          include_images: exportType === 'detailed' ? '1' : '0',
        });

        // Make the request to download Excel file
        const response = await axios.get(`gift_redemptions/excel_export?${query}`, {
          responseType: 'blob', // Important for file downloads
        });

        // Create blob URL and trigger download
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        // Generate filename with current date
        const today = new Date().toISOString().split('T')[0];
        link.download = `gift_redemptions_${today}.xlsx`;
        
        // Trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Cleanup
        window.URL.revokeObjectURL(url);
        
        // Show success message (optional)
        this.$toast.success('Excel file downloaded successfully!');
      } catch (error) {
        console.error('Download failed:', error);
        this.$toast.error('Failed to download Excel file. Please try again.');
      } finally {
        this.isDownloading = false;
      }
    },
    showImageModal(imagePath) {
      this.selectedImagePath = imagePath;
      this.imageModal = true;
    },
    openImageInNewTab() {
      if (this.selectedImagePath) {
        const imageUrl = this.mediaUrl + this.selectedImagePath;
        window.open(imageUrl, '_blank');
      }
    },
    closeExcelDialog() {
      this.showExcelDialog = false;
      // Reset dialog filters
      this.downloadDialog.from_date = null;
      this.downloadDialog.to_date = null;
      this.downloadDialog.fromDateMenu = false;
      this.downloadDialog.toDateMenu = false;
    },
    async downloadExcelFromDialog() {
      await this.downloadExcel(
        this.downloadDialog.from_date, 
        this.downloadDialog.to_date, 
        this.downloadDialog.exportType
      );
      this.closeExcelDialog();
    },
    updateExportDescription() {
      if (this.downloadDialog.exportType === 'fast') {
        this.downloadDialog.exportDescription = 'Quick download with all data except images. Recommended for large datasets.';
      } else {
        this.downloadDialog.exportDescription = 'Complete export including embedded images. May take longer for large datasets.';
      }
    },
    formatDateDisplay(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
  },
};
</script>

<style scoped>
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
  min-height: 60px;
  color: #9e9e9e;
}

.cursor-pointer {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.cursor-pointer:hover {
  opacity: 0.8;
}

.v-img {
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
</style>
